import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {isTaskTipCountValid} from 'lib/cardAndTaskHelper';
import {useMemo} from 'react';
import {getMaxWellTipPositionValue} from 'lib/PipettingProfileItemHelper';
import {parseMessage} from '../../../../../lib/stringHelper';
import PipettingProfileInputType from '../PipettingProfileInputType';
import {PipettingProfileItemWrapper} from '../PipettingProfileWrapper';
import {getLabwareDataById} from '../../../../../stores/selectors/labwareStateSelectors';
import {getMinTipPositionByLabwareId} from '../../../../../stores/business/protocolManagementBusiness';
import {getWellDepth} from '../../../VirtualTray/labwareHelper';
import {DirectionType, TaskType} from '../../../../../constants/dataEnum';
import PopupPipettingTipPositionInfo from './ItemInfo/PopupPipettingTipPositionInfo';
import PipettingItemTipDirection from './PipettingItemTipDirection';

function PipettingItemTipPosition({task, onChange, onXTipPositionOnChange, onYTipPositionOnChange}) {
  const dispatch = useDispatch();

  const {type, labwareID, tipPosition} = task || {};

  const labware = useSelector(getLabwareDataById(labwareID));

  const labelAspirate = parseMessage('protocolEditor.taskList.pipettingProfile.aspirateTipPosition');
  const labelDispense = parseMessage('protocolEditor.taskList.pipettingProfile.dispenseTipPosition');
  const labelHigh = parseMessage('protocolEditor.taskList.pipettingProfile.tipPositionHeight');

  const label = type === TaskType.ASPIRATE ? labelAspirate : labelDispense;

  const getMinTipPosition = () => dispatch(getMinTipPositionByLabwareId(labwareID, true));
  const tipPositionOffsetMaxValue = useMemo(() => getMaxWellTipPositionValue(labware), [labware]);
  const isAllowChange = isTaskTipCountValid(task, labware);
  const maxHeight = getWellDepth(labware);

  return (
    <>
      <div className="pipetting-profile__item">
        <div className="pipetting-profile__item__tip-position-title">
          {label}
          :
          <PopupPipettingTipPositionInfo />
        </div>
      </div>
      <PipettingProfileItemWrapper>
        <li>{labelHigh}</li>
        <PipettingProfileInputType.NumericTextBox
          value={tipPosition > maxHeight ? onChange(maxHeight, type) : tipPosition}
          minValue={getMinTipPosition()}
          maxValue={maxHeight}
          onChange={(value) => onChange(value, type)}
        />
        <PipettingProfileInputType.Unit.MillimeterAboveBottomWell />
        {isAllowChange && (
          <>
            <PipettingItemTipDirection
              task={task}
              direction={DirectionType.DIRECTION_X}
              maxValueOffset={tipPositionOffsetMaxValue?.x}
              onChange={onXTipPositionOnChange}
            />
            <PipettingProfileInputType.Unit.MillimeterFromCenterWell />
            <PipettingItemTipDirection
              task={task}
              direction={DirectionType.DIRECTION_Y}
              maxValueOffset={tipPositionOffsetMaxValue?.y}
              onChange={onYTipPositionOnChange}
            />
            <PipettingProfileInputType.Unit.MillimeterFromCenterWell />
          </>
        )}
      </PipettingProfileItemWrapper>
    </>
  );
}

PipettingItemTipPosition.propTypes = {
  onXTipPositionOnChange: PropTypes.func.isRequired,
  onYTipPositionOnChange: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
};

export default PipettingItemTipPosition;
